import { mergeStyles } from '@fluentui/react';
import React from 'react';

interface IDetailsContentContainerProps {
  readonly contentId: string;
  readonly actionButtonId: string;
}

export const DetailsContentContainer: React.FC<IDetailsContentContainerProps> = ({
  contentId,
  actionButtonId,
  children,
}) => {
  const className = mergeStyles({
    paddingLeft: 8,
  });

  return (
    <div id={contentId} className={className} role="region" aria-labelledby={actionButtonId}>
      {children}
    </div>
  );
};
